// (C) Copyright 2024 Hewlett Packard Enterprise Development LP

export const readStatus = Object.freeze({
  read: 'Read',
  unread: 'Unread',
  all: 'All',
  mark_read: 'Mark as read',
  mark_unread: 'Mark as unread'
})
